import { type RestaurantBranding } from "api-types";

import { type ReduxState } from "@dashboard/types/reduxState";

import { RestaurantSelectedAction } from "./restaurantReducer";

export type BrandingReducerAction =
  | RestaurantSelectedAction
  | { type: "FETCHED_BRANDING"; payload: RestaurantBranding }
  | { type: "SET_BRANDING"; payload: RestaurantBranding }
  | { type: "UPDATING_BRANDING"; payload: boolean }; // payload is dishId

export const brandingReducer = (
  state: ReduxState["branding"] = {
    initialBrandingLoading: true,
    branding: {} as RestaurantBranding,
    updatingBranding: false,
  },
  action: BrandingReducerAction
) => {
  switch (action.type) {
    case "RESTAURANT_SELECTED":
      return {
        ...state,
        initialBrandingLoading: true,
      };
    case "SET_BRANDING":
      return {
        ...state,
        branding: action.payload,
        updatingBranding: false,
      };
    case "FETCHED_BRANDING":
      return {
        ...state,
        branding: action.payload,
        initialBrandingLoading: false,
      };
    case "UPDATING_BRANDING":
      return {
        ...state,
        updatingBranding: action.payload,
      };
    default:
      return state;
  }
};
